import { useCallback, useEffect } from "react";
import { isNumber } from "lodash";

type Locks = {[index:string]: number}

const locks: Locks = {};

type QueryLock = {isLocked: () => boolean}

export function useQueryLock(key: string): QueryLock {
    const isLocked = useCallback(() => {
        const count = locks[key];
        return count !== undefined && count > 1;
    }, [key]);

    useEffect(() => {
        if (isNumber(locks[key])) {
            locks[key]++;
        } else {
            locks[key] = 1;
        }
        return () => {
            locks[key]--;
        };
    });
    
    return {isLocked};
}